(function () {
  if (window.innerWidth < 1024) return;

  const wrapper = document.getElementById('video-flotante-wrapper');
  const closeBtn = document.getElementById('video-flotante-close');

  if (!wrapper || !closeBtn) return;

  let cerrado = false;

  closeBtn.addEventListener('click', function () {
    cerrado = true;

    wrapper.querySelectorAll('video').forEach(function (video) {
      video.pause();
      video.currentTime = 0;
    });

    // Detiene también reproductores de YouTube o Vimeo.
    wrapper.querySelectorAll('iframe').forEach(function (iframe) {
      iframe.src = 'about:blank';
    });

    wrapper.classList.add('oculto');
    wrapper.style.display = 'none';
  });

  const mediaGallery = document.querySelector(
    '.product__media-wrapper, .product-media-container, [data-product-media-container]'
  );

  if (mediaGallery) {
    const observer = new IntersectionObserver(
      function (entries) {
        if (cerrado) return;

        entries.forEach(function (entry) {
          wrapper.classList.toggle('oculto', entry.isIntersecting);
        });
      },
      { threshold: 0.3 }
    );

    observer.observe(mediaGallery);
  }
})();
